import { render, staticRenderFns } from "./uploadVedio.vue?vue&type=template&id=0f3418be&scoped=true"
import script from "./uploadVedio.vue?vue&type=script&lang=js"
export * from "./uploadVedio.vue?vue&type=script&lang=js"
import style0 from "./uploadVedio.vue?vue&type=style&index=0&id=0f3418be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3418be",
  null
  
)

export default component.exports